import {
  RecoverPasswordParams,
  LoginParams,
  RecoverPasswordFormParams,
  SetForgotPassword,
  SignInParams,
  LoginFormParams,
} from './Types';

import {
  validateSetStage,
  validateParams,
  validateSetState,
} from '../Validator';

export const validateRecoverPasswordParams = (
  params: RecoverPasswordParams,
): void => {
  validateParams(params);
  validateSetState(params.setState);
  validateSetStage(params.setStage);
};

export const validateRecoverPasswordFormParams = (
  params: RecoverPasswordFormParams,
): void => {
  validateParams(params);
  validateSetState(params.setState);
  validateSetStage(params.setStage);
};

export const validateLoginParams = (params: LoginParams): void => {
  validateParams(params);
  validateSetState(params.setState);
};

export const validateLoginFormParams = (params: LoginFormParams): void => {
  validateParams(params);
  validateSetState(params.setState);
};

export const validateSignInParams = (params: SignInParams): void => {
  validateParams(params);
  validateLoginFormParams(params);
  validateRecoverPasswordFormParams(params);
};
